import { clearHighlight } from "../direct.js";

export let FirstMenuAnnotation = {
  name: 'annotation',
  title: 'Edit annotations',
  shortcut: 'n'
}

export function queryMarkLabels(uid, label) {
  let annos = Array.from(document.querySelectorAll("#artboard-" + uid + " annotation"));
  let repls = Array.from(document.querySelectorAll("#artboard-" + uid + " replacement"));
  let anno_objs = annos.filter((an) => {
    return an.classList.contains(
      "F_layer_" +
      label.layerIndex +
      "__markLabel_" +
      label.textIndex +
      "_" +
      label.field
    );
  });
  let repl_objs = repls.filter((an) => {
    return an.classList.contains(
      "F_layer_" +
      label.layerIndex +
      "__markLabel_" +
      label.textIndex +
      "_" +
      label.field
    );
  })
  let objs = [];
  objs.push(...anno_objs);
  objs.push(...repl_objs)
  return objs;
  // class: F_layer_0__markLabel_0_label
  // data-name: on-mark-anno-label-38
}
export function findLabel(uid, label, cls) {
  let cls_name = { find: "dupo-g-found", hide: "dupo-g-hidden", unhide: "dupo-g-hidden" }[cls];
  queryMarkLabels(uid, label).forEach((an) => {
    if (cls === "unhide") { an.classList.remove(cls_name); }
    else { an.classList.add(cls_name); }
  });
}
export function unfindLabel() {
  clearHighlight();
}

export function queryAnnotation(uid, annotation) {
  let annos = Array.from(document.querySelectorAll("#artboard-" + uid + " annotation"));
  let external_annos = Array.from(document.querySelectorAll("#artboard-" + uid + " div[data-role=\"externalAnnotation\"]"));
  annos.push(...external_annos);
  return annos.filter((an) => {
    return an.getAttribute("data-name") === annotation.name;
  });
}
export function findAnnotation(uid, annotation, cls) {
  let cls_name = { find: "dupo-g-found", hide: "dupo-g-hidden", unhide: "dupo-g-hidden" }[cls];
  queryAnnotation(uid, annotation).forEach((an) => {
    if (cls === "unhide") { an.classList.remove(cls_name); }
    else { an.classList.add(cls_name); }
  });
}
export function unfindAnnotation() {
  clearHighlight();
}